/* --------------------------------------------------------------------------
	Transitions
-------------------------------------------------------------------------- */

/* globals jQuery, Site */

(function ($, Site) {
	function init() {
		if (!$('.js-transition-component').length) {
			return;
		}

		if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
			var observer = new IntersectionObserver(
				function (entries) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting === true) {
							entry.target.classList.add('in_view');
						}
					});
				},
				{
					threshold: 0.5
				}
			);

			var items = document.querySelectorAll('.js-transition-item');

			items.forEach(function (item, index) {
				observer.observe(item, index);
			});
		} else {
			$('.js-transition-item').addClass('in_view');
		}
	}

	Site.OnInit.push(init);
})(jQuery, Site);
